<template>
  <div>
    <el-container>
      <el-aside width="auto">
          <main-aside/>
      </el-aside>
      <el-container>
        <el-header>
            <main-header/>
        </el-header>
        <el-main style="height:0;flex-grow:1;">
            <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import MainAside from '@/components/MainAside.vue'
import MainHeader from '@/components/MainHeader.vue';
export default {
  name: "Main",
  data(){
      return{

      }
  },
  components:{
    MainAside,
    MainHeader
  }
};
</script>

<style scoped>
  div{
    width: 100%;
    height: 100%;
  }
  .el-header{
    padding: 0;
    margin: 0;
  }
</style>
